export default {
  accounts: [],
  isFetchingInitialDataForAddAndEditModal: false,
};
